import ApiService from '@/services/api.service.js';

export const MessagingService = {

  sendNotification: function (data) {
    return ApiService.post('/messaging/sendNotification', data);
  },

  sendEmail: function (data) {
    return ApiService.post('/messaging/sendEmail', data);
  }

}

export default MessagingService